import { render, staticRenderFns } from "./CarnivalSearch.vue?vue&type=template&id=2053930a&scoped=true"
import script from "./CarnivalSearch.vue?vue&type=script&lang=js"
export * from "./CarnivalSearch.vue?vue&type=script&lang=js"
import style0 from "./CarnivalSearch.vue?vue&type=style&index=0&id=2053930a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2053930a",
  null
  
)

export default component.exports